﻿import React, { useContext, useEffect, useState } from 'react';

import { BreadCrumbNavigation, StageBreadCrumb } from 'components/BreadCrumbNavigation/BreadCrumbNavigation';
import { OrderFillForm } from 'pages/partners/components/OrdersTab/components/OrderFillForm/OrderFillForm';
import type { AutoFillOption, OrderStageOption } from 'pages/partners/components/OrdersTab/OrdersTab';
import { OrderApi, OrderInventory } from 'apis/OrderApi';
import { usePartners } from 'pages/partners/context';
import { PartnerDetails } from 'apis/PartnerApi';
import { License } from 'apis/LicenseApi';

import 'components/PlaceAnOrder/place-an-order.scss';

interface PlaceAnOrderProps {
	breadCrumbs: StageBreadCrumb<OrderStageOption>[]
	details: PartnerDetails;
	getAllOrdersFiltered: (placeNewOrder?: boolean) => void
	handleBreadCrumbClick: (currentBreadCrumb: StageBreadCrumb<OrderStageOption>) => void
    orderableLicenses: License[];
    orderAutoFillOptions: AutoFillOption[];
    setOrderAutoFillOptions: React.Dispatch<React.SetStateAction<AutoFillOption[]>>;
}

export function PlaceAnOrder({
    breadCrumbs,
    details,
    getAllOrdersFiltered,
    handleBreadCrumbClick,
    orderableLicenses,
    orderAutoFillOptions,
    setOrderAutoFillOptions
}: PlaceAnOrderProps) {

    const { highestRolePartnerId } = usePartners();
    const [orderInventory, setOrderInventory] = useState<OrderInventory[]>([]);

    useEffect(() => {

        OrderApi.GetOrderInventory(highestRolePartnerId).then(setOrderInventory).catch(console.error);

    }, []);

    return (
        <>
            <BreadCrumbNavigation breadCrumbs={breadCrumbs} handleBreadCrumbClick={handleBreadCrumbClick} />
            <OrderFillForm
                details={details}
                getAllOrdersFiltered={getAllOrdersFiltered}
                orderableLicenses={orderableLicenses}
                orderAutoFillOptions={orderAutoFillOptions}
                orderInventory={orderInventory}
                page={{ selectedOrder: undefined, type: 'Place' }}
                setOrderAutoFillOptions={setOrderAutoFillOptions}
            />
        </>
    );

}
